import getPreviewToken from './get-preview-token';

function getPreviewMiddleware(app) {
  return (_, { headers }) => {
    const previewToken = getPreviewToken(app);
    if (!previewToken) return { headers };

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${previewToken}`
      }
    };
  };
}
export default getPreviewMiddleware;
